import React, { useState } from 'react';

import classes from './Property.module.css';
import PropertyOption from './PropertyOption';

import MaterialCloseIcon from '../Core/MaterialIcons/MaterialCloseIcon';

const sortingBasedOnShortlistedOrder = (options) => {
  return options?.sort((a, b) => a.shortlistedOrder - b.shortlistedOrder);
};

const AddPropertyForTour = ({ options, onNextClick, onCancelClick }) => {
  const [selectedProperties] = useState(sortingBasedOnShortlistedOrder(options));
  const [selectedPropertiesCount, setSelectedPropertiesCount] = useState(
    options?.filter((option) => option.isSelectedForTour)?.length,
  );

  const summary = `Properties for Tour (${options?.length}):`;

  const selectedProperty =
    selectedPropertiesCount == 1
      ? selectedPropertiesCount + ` Property Selected`
      : selectedPropertiesCount + ` Properties Selected`;

  const cancelClickHandler = () => {
    onCancelClick();
  };

  const nextClickHandler = () => {
    onNextClick(selectedProperties);
  };

  const unselectAllHandler = () => processProperties();

  const addToTourList = (optionId) => processProperties(optionId, true);

  const removeFromTourList = (optionId) => processProperties(optionId);

  const processProperties = (optionId, isAdd) => {
    if (optionId) {
      selectedProperties.forEach((option) =>
        option.id === optionId ? (option.isSelectedForTour = isAdd ? true : false) : option,
      );
      selectedProperties.sort((a, b) => b.isSelectedForTour - a.isSelectedForTour);
    } else {
      selectedProperties.forEach((option) => (option.isSelectedForTour = false));
    }
    setSelectedPropertiesCount(
      selectedProperties.filter((option) => option.isSelectedForTour).length,
    );
  };

  return (
    <>
      <div className={classes.heading}>
        <h4>Request for Tour </h4>
        {selectedPropertiesCount > 0 && (
          <div className={classes.headingSelected}>
            {selectedProperty}
            <button
              className={`${classes.button} ${classes.text}`}
              disabled={selectedPropertiesCount === 0}
              onClick={unselectAllHandler}
            >
              <MaterialCloseIcon></MaterialCloseIcon>
            </button>
          </div>
        )}
      </div>
      <div className={classes.summaryHeader}>{summary}</div>
      <div className={classes['properties_container']}>
        {selectedProperties &&
          selectedProperties.map((option, index) => (
            <PropertyOption
              option={option}
              index={String(index + 1).padStart(2, '0')}
              key={option.id}
              addToTourList={addToTourList}
              removeFromTourList={removeFromTourList}
            />
          ))}
      </div>
      <div className={classes.buttonContainer}>
        <h5 className={classes.pageNo}>1 of 2</h5>
        <button className="button secondary" onClick={cancelClickHandler}>
          Cancel
        </button>
        <button
          className="button primary"
          disabled={selectedPropertiesCount === 0}
          onClick={nextClickHandler}
        >
          Select Time Slot
        </button>
      </div>
    </>
  );
};

export default AddPropertyForTour;
